module.exports = __webpack_public_path__ + "static/fonts/CoHeadlineCorp-Regular.423c14c.ttf";